// extracted by mini-css-extract-plugin
export default {"name_container":"StudentNameComponent_name_container__X+yTQ","student_name":"StudentNameComponent_student_name__ZsU-M","avatar":"StudentNameComponent_avatar__UB3qp"};